import React, { useContext } from 'react'
import { SidebarContext } from '../context/SidebarContext'
import MainApp from '../components/Sidebar/MainApp'
import Collapsed from '../components/Sidebar/Collapsed'

export default function Sidebar({ usrRole, isMobile }) {
    const { isOpen } = useContext(SidebarContext)
    return (
        <div>
            {/* {isOpen ?
                <MainApp mobileSidebar={isMobile} />
                :
                <Collapsed />
            } */}
            <MainApp mobileSidebar={isMobile} />
        </div>

    )
}